import { getUserProfile } from '../../apiClient';
import { useAuthStore } from '../../../store';
import { useMutation } from '@tanstack/react-query';

const useGetProfile = () => {
    const setAuthToken = useAuthStore((state) => state.setAuthToken);
    const setUserProfile = useAuthStore((state) => state.setUserProfile);
    const profileMutation = useMutation({
        mutationKey: 'user_profile',
        mutationFn: () => getUserProfile(),
        onSuccess: (data) => {
            setUserProfile(data);
        },
        onError: () => {
            setAuthToken(null);
            setUserProfile(null);
        },
    });
    return profileMutation;
};
export default useGetProfile;
